import { render, staticRenderFns } from "./MenuLinkV4.vue?vue&type=template&id=d37ecf06"
import script from "./MenuLinkV4.vue?vue&type=script&lang=js"
export * from "./MenuLinkV4.vue?vue&type=script&lang=js"
import style0 from "./MenuLinkV4.vue?vue&type=style&index=0&id=d37ecf06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports